// src/features/feeds/components/CreateFeedModal.tsx

import { Modal, Stack, TextInput, Button, Group, Text } from '@mantine/core';
import { useState } from 'react';
import { FEED_CONSTRAINTS } from '@/lib/constants/feed';

interface CreateFeedModalProps {
  opened: boolean;
  onClose: () => void;
  onSubmit: (title: string) => void;
  loading?: boolean;
}

export function CreateFeedModal({ opened, onClose, onSubmit, loading }: CreateFeedModalProps) {
  const [title, setTitle] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = () => {
    const trimmed = title.trim();
    if (trimmed.length < FEED_CONSTRAINTS.TITLE_MIN) {
      setError('Title is required');
      return;
    }
    if (trimmed.length > FEED_CONSTRAINTS.TITLE_MAX) {
      setError(`Max ${FEED_CONSTRAINTS.TITLE_MAX} characters`);
      return;
    }
    setError(null);
    onSubmit(trimmed);
  };

  const handleClose = () => {
    setTitle('');
    setError(null);
    onClose();
  };

  return (
    <Modal opened={opened} onClose={handleClose} title="Create Feed" size="sm">
      <Stack gap="md">
        <TextInput
          label="Title"
          placeholder="Enter feed title"
          value={title}
          onChange={(e) => { setTitle(e.currentTarget.value); setError(null); }}
          maxLength={FEED_CONSTRAINTS.TITLE_MAX}
          error={error}
          description={`${title.length}/${FEED_CONSTRAINTS.TITLE_MAX}`}
          data-autofocus
          onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
        />

        <Group justify="flex-end">
          <Button variant="default" onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} loading={loading} disabled={title.trim().length === 0}>
            Create
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
